"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHistory = void 0;
const updateHistory = (application_history, user, action) => {
    var _a, _b;
    let localHistory = [...(application_history !== null && application_history !== void 0 ? application_history : [])];
    localHistory.push({
        action: action,
        timestamp: Date.now(),
        user: (_b = (_a = user.name) !== null && _a !== void 0 ? _a : user.username) !== null && _b !== void 0 ? _b : user.email,
    });
    localHistory = localHistory.slice(0, 20);
    return localHistory;
};
exports.updateHistory = updateHistory;
